import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { KhubMap } from '../../../components'
import { fetchBranches, fetchHeadquarter } from '../../../features/organization/slice'

// When integrated with API, get this data from database
// const mapData = [
//   {
//     name: 'Peacegen Indonesia',
//     id: 'peacegen-indonesia',
//     type: 'place',
//     coordinate: {
//       lat: -6.945979,
//       lng: 107.626622,
//     },
//     markerType: 'headquarter',
//     content: '<div class="border-b border-solid mb-2 pb-2">NGO / Headquarter</div><p>Jl. Cijagra, Cijagra, Kec. Lengkong, Kota Bandung, Jawa Barat 40265</p>',
//   },
//   {
//     name: 'CSO Sample 1',
//     id: 'cso-sample-1',
//     type: 'headquarter',
//     coordinate: {
//       lat: -7.931037,
//       lng: 112.638990,
//     },
//     markerType: 'organization',
//     content: '<div class="border-b border-solid mb-2 pb-2">CSO</div><p>Lorem ipsum dolor sit amet</p>',
//   }
// ]

const Map = ({
  style = {
    backgroundColor: '#fff',
    minHeight: '282px',
    height: '282px'
  },
  mapClassName
}) => {
  const dispatch = useDispatch()
  const detailedHeadquarter = useSelector(state => state.organization.headquarter)
  const detailedBranches = useSelector(state => state.organization.branches)
  const data = useSelector(state => state.organization.data)

  const {
    pin_points,
    headquarter,
    branches,
    is_headquarter
  } = data

  const {
    pin_points: headquarter_pin_points
  } = detailedHeadquarter

  const changeMarkerType = (input = [], markerType) => {
    let output = []

    if(input && input.length > 0){
      for (let index = 0; index < input.length; index++) {
        const element = input[index];
        output.push({
          ...element,
          markerType
        })
      }
    }

    return output
  }

  const generateMapData = React.useCallback(() => {
    let result = []

    // My Organization Map Data
    if(pin_points && pin_points.length > 0){
      if(is_headquarter){
        const converted = changeMarkerType(pin_points, 'headquarter')
        result = [...converted]
      } else {
        result = [...pin_points]
      }
    }

    // My Headquarter Map Data
    if(headquarter_pin_points && headquarter_pin_points.length > 0){
      const converted = changeMarkerType(headquarter_pin_points, 'headquarter')
      result = [...result, ...converted]
    }

    // My Branches Map Data
    if(detailedBranches && detailedBranches.length > 0){
      let branchPinPoints = []

      for (let index = 0; index < detailedBranches.length; index++) {
        const element = detailedBranches[index];
        branchPinPoints = [...branchPinPoints, ...element.pin_points]
      }

      result = [...result, ...branchPinPoints]
    }

    return result
  }, [pin_points, headquarter_pin_points, detailedBranches, is_headquarter])

  const mapData = generateMapData()

  // Fetch headquarter detail
  React.useEffect(() => {
    if(headquarter && headquarter.id){
      dispatch(fetchHeadquarter(headquarter.id))
    }
  }, [dispatch, headquarter])

  // Fetch branches detail
  React.useEffect(() => {
    if(branches && branches.length > 0){
      dispatch(fetchBranches(branches))
    }
  }, [dispatch, branches])

  return (
    <KhubMap
      data={mapData}
      mapStyleColor="light"
      style={style}
      mapClassName={mapClassName}
    />
  )
}

export default Map
